$(document).on('click','.cart-icon--basket2',function(e){
  e.preventDefault();
  $('.main-cart-drawer').addClass('active');
});

$(document).on('click','.drawer__close,.cart-drawer__overlay',function(){
  $(this).closest('.main-cart-drawer').removeClass('active');
});

function cart_updation(item_id,qty){
  var item_data={  
   id: item_id,
   quantity: qty
  }
  $.ajax({
     type: 'POST', 
     url: '/cart/change.js',
     dataType: 'json', 
     data: item_data,
     success: function (product){
      $.ajax({
        url:'/',
        type:'GET',
        success: function(data){
          var a=$('.cart-drawer-item').html($(data).find('.cart-drawer-item').html());
          jQuery.getJSON('/cart.js', function(cart) {
            if(cart.item_count == 0){
              $('.cart-drawer-item, .main-cart-drawer').addClass('is-empty');
            }else{
              $('.cart-drawer-item, .main-cart-drawer').removeClass('is-empty');
            }
            $('.cart-icon--basket2>div').html(cart.item_count);
           recommendedpr();
          });
        }
      });
       console.log("success");
     },
     error: function(){   
       console.log("error");
     }
  });
}


$(document).on('click','.cart-item__quantity-wrapper .quantity__button',function(){
  var qty = parseInt(
    $(this).parent('.quantity').find('input').val()
  );
  if ($(this).attr('name') == 'plus') {
    qty = qty + 1;
  } else {
    if (qty > 1) {
      qty = qty - 1;
    }
  }
  qty = isNaN(qty) ? 1 : qty;
  $(this).parent('.quantity').find('input').val(qty);
  var item_id = $(this).closest('.cart-item').attr('data-id');
  cart_updation(item_id,qty);
  
});

$(document).on('click','.cart-remove-button button',function(){
  var item_id = $(this).closest('.cart-item').attr('data-id');
  var qty = 0;
  cart_updation(item_id,qty);
  
});